import i18n from "@/i18n"
import { RouteRecordRaw } from "vue-router"

const { t } = i18n.global

const guardaDaRotaDeCriarNovaSenha = (rotaDeEntrada, de, proximaRota): void => {
  const chaveDeRecuperacaoDeSenha = rotaDeEntrada.query.codigo

  if (!chaveDeRecuperacaoDeSenha) {
    proximaRota({ name: "Login" })
  } else {
    proximaRota()
  }
}

export const autenticacaoRotas = (): RouteRecordRaw[] => [
  {
    path: "/auth",
    name: "Login",
    meta: {
      titulo: t("tituloDaRotaDeLogin"),
      regras: ["livre"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Autenticacao" */
        "@/paginas/Conta/Login/Login.vue"
      ),
  },
  {
    path: "/auth/recuperacao-de-senha",
    name: "RecuperarSenha",
    meta: {
      titulo: t("tituloDaRotaDeRecuperacaoDeSenha"),
      regras: ["livre"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Recuperar a Senha" */
        "@/paginas/Conta/RecuperacaoDeSenha.vue"
      ),
  },
  {
    path: "/auth/criar-nova-senha",
    name: "CriarNovaSenha",
    meta: {
      titulo: t("tituloDaRotaDeCriarNovaSenha"),
      regras: ["livre"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Inserir nova senha" */
        "@/paginas/Conta/CriarNovaSenha.vue"
      ),
    beforeEnter: guardaDaRotaDeCriarNovaSenha,
  },
  {
    path: "/auth/single-sign-on",
    name: "SingleSignOn",
    meta: {
      title: t("tituloDaRotaDeSingleSignOn"),
      regras: ["livre"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Inserir nova senha" */
        "@/paginas/Conta/SingleSignOn.vue"
      ),
  },
]
